class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.delay = Number(this.dataset.delay || 0) * 1000;
    this.closed = getCookie('newsletter-closed');
    this.subscribed = getCookie('newsletter-subscribed');
    this.form = this.querySelector('.js-form');
    this.ageVerificationPopup = document.querySelector('age-verification-popup');

    if (this.form) {
      this.form.addEventListener('submit', this.onSubscribe.bind(this));
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === 'true') {
        this.show();
      }
      return;
    }

    // Helper: open popup + lock close button for 2s
    const openWithLock = (popupEl) => {
      popupEl.show();

      const closeBtn = popupEl.querySelector('.newsletter-popup__close');
      if (closeBtn) {
        closeBtn.disabled = true;
        setTimeout(() => {
          closeBtn.disabled = false;
        }, 1000);
      }
    };

    if (this.ageVerificationPopup) {
      let prevClassState = this.classList.contains('newsletter-popup-is-hidden');
      const newsletterPopup = this;

      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName !== 'class') return;

          const currentClassState = mutation.target.classList.contains(
            'newsletter-popup-is-hidden'
          );

          if (prevClassState !== currentClassState) {
            prevClassState = currentClassState;

            // When age verification is no longer hidden, show newsletter after delay
            if (!currentClassState) {
              setTimeout(() => {
                if (
                  newsletterPopup.closed !== null ||
                  newsletterPopup.subscribed !== null
                )
                  return;

                openWithLock(newsletterPopup);
              }, newsletterPopup.delay);
            }
          }
        });
      });

      observer.observe(this, { attributes: true });
    } else {
      setTimeout(() => {
        if (this.closed !== null || this.subscribed !== null) return;

        openWithLock(this);
      }, this.delay);
    }
  }

  hide() {
    super.hide();
    setCookie('newsletter-closed', 'true');
  }

  onSubscribe() {
    setCookie('newsletter-subscribed', 'true');
    this.hide();
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
